// Cards, dropdown choices and filtering must use the same four keys.
export function normalizeWorkModel(value) {
  const key = String(value || '').toLowerCase().replace(/[\s-]/g, '');
  return ['onsite', 'hybrid', 'remote'].includes(key) ? key : 'unknown';
}
